export default "__VITE_ASSET__aeb83344__"